import React from "react";
import { SurahTitle, Bismillah, Word } from "../quranVerses/QuranVerses.styled";

const SMALL_VIEWPORT_BREAKPOINT = 640;

export const renderLinesWithSurahTitles = (lines, surahs, currentPage) => {
  const renderedLines = [];
  const renderedChapters = [];
  const isMobile = window.innerWidth <= SMALL_VIEWPORT_BREAKPOINT;

  Object.entries(lines).forEach(([lineNumber, lineData]) => {
    const { words, surahNumBeforeLine } = lineData;

    if (surahNumBeforeLine && !renderedChapters.includes(surahNumBeforeLine)) {
      renderedChapters.push(surahNumBeforeLine);

      renderedLines.push(
        <SurahTitle key={`surah-${surahNumBeforeLine}`}>
          {String(surahNumBeforeLine).padStart(3, "0")}surah
        </SurahTitle>
      );

      if (surahNumBeforeLine !== "1" && surahNumBeforeLine !== "9") {
        renderedLines.push(
          <Bismillah key={`bismillah-${surahNumBeforeLine}`}>﷽</Bismillah>
        );
      }
    }

    renderedLines.push(
      <div key={lineNumber}>
        {words.map((word) => (
          <Word key={word.id} currentPage={currentPage} isMobile={isMobile}>
            {word.text}
          </Word>
        ))}
      </div>
    );
  });

  return renderedLines;
};
